import React from 'react';
import { useParams } from 'react-router-dom';
import PrivacyPolicyES from './privacyPolicyES';
import PrivacyPolicyEN from './privacyPolicyEN';
import PrivacyPolicyCA from './privacyPolicyCA';

const PrivacyPolicy: React.FC = () => {
    const { lang } = useParams<{ lang?: string }>();
    const storedLang = localStorage.getItem('language');
    const language = lang || storedLang || 'es';

    switch (language) {
        case 'en':
            return <PrivacyPolicyEN />;
        case 'ca':
            return <PrivacyPolicyCA />;
        case 'es':
            return <PrivacyPolicyES />;
        default:
            return <PrivacyPolicyES />;
    }
};

export default PrivacyPolicy;
